import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

function AboutUs() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow bg-gray-50 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">About BoardVoyage</h1>
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-lg text-gray-700 mb-4">
              BoardVoyage is your gateway to discovering and connecting with local board game clubs and communities.
            </p>
            <p className="text-gray-600 mb-4">
              We believe that board games bring people together, fostering friendships, strategic thinking, and memorable experiences. Our mission is to make it easier for enthusiasts to find their perfect gaming community.
            </p>
            <p className="text-gray-600">
              Whether you're a casual player or a hardcore strategist, BoardVoyage helps you discover clubs that match your interests and connect with fellow gamers in your area.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AboutUs;
